import PropTypes from 'prop-types';
import React from 'react';
import HotelFeedbackForm from './HotelFeedbackForm';
import HotelUnsubscribeForm from './HotelUnsubscribeForm';
import HotelDetail from '../../../components/HotelDetail/HotelDetail';

class HotelFeedback extends React.Component {
  constructor(props) {
    super(props);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentWillMount() {
    this.props.loadHotel(this.props.hotelId);
  }
  getForm(action) {
    const initialValues = {
      hotel: this.props.hotelId,
    };
    if (action === 'unsubscribe') {
      return (
        <HotelUnsubscribeForm initialValues={initialValues} handleRemove={this.handleRemove} />
      );
    }
    initialValues.state = 'NE';
    return <HotelFeedbackForm initialValues={initialValues} onSubmit={this.handleSubmit} />;
  }
  handleSubmit(values) {
    return this.props.sendHotelFeedback(values);
  }
  handleRemove() {
    return this.props.hotelUnsubscribe(this.props.hotelId);
  }
  render() {
    if (this.props.needFetch || this.props.isFetching) {
      return null;
    }
    const form = this.getForm(this.props.action);
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">{form}</div>
        </div>
        <hr />
        {this.props.hotel && <HotelDetail hotel={this.props.hotel} />}
      </div>
    );
  }
}

HotelFeedback.propTypes = {
  hotelId: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  hotel: PropTypes.object,
  needFetch: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  loadHotel: PropTypes.func.isRequired,
  sendHotelFeedback: PropTypes.func.isRequired,
  hotelUnsubscribe: PropTypes.func.isRequired,
};

export default HotelFeedback;



// WEBPACK FOOTER //
// src/routes/feedback/components/HotelFeedback.js